export default "__VITE_ASSET__Bg2jk6Z1__"